import { render, staticRenderFns } from "./IconEnvelope.vue?vue&type=template&id=6ded51da&scoped=true&"
import script from "./IconEnvelope.vue?vue&type=script&lang=js&"
export * from "./IconEnvelope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded51da",
  null
  
)

export default component.exports